/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type { MeSetLangOptions, MeSetLangResponses } from '../models/MeSetLang'
import {
  meSetLangResponseSchema,
  meSetLangErrorSchema,
  meSetLangBodySchema,
} from '../schemas/meSetLangSchema'

/**
 * @summary Switch the UI language: saves it on the user record and logs UserLanguageChange. Result is ALWAYS
 * the user's effective language — the new code on success, the actual current one on failure.
 * {@link /api/v4/me/setLang}
 */
export function meSetLang<ThrowOnError extends boolean = true>(
  options: Options<MeSetLangOptions, ThrowOnError>
): Unwrappable<RequestResult<MeSetLangResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/api/v4/me/setLang',
      security: [{ type: 'http', scheme: 'bearer' }],
      validator: {
        request: meSetLangBodySchema,
        response: meSetLangResponseSchema,
        error: meSetLangErrorSchema,
      },
      contentType: { request: 'application/json-patch+json' },
      ...config,
    }) as Promise<RequestResult<MeSetLangResponses, ThrowOnError>>
  )
}
